export const deleteEmptyFieldsObject = (obj = {}) => {
  if (typeof obj === 'object' && obj !== null) {
    Object.entries(obj).forEach(([key, value]) => !value && delete obj[key])
  } else {
    throw new Error(`Error at deleteEmptyObjectFields(...): ${obj} is not an object`)
  }
}

export default deleteEmptyFieldsObject
